import { createAsyncThunk } from '@reduxjs/toolkit';
import { getClientPortalConfigurations } from 'services/pod';
import { IClientPortalConfiguration } from '../../../services/pod/types';

export const ThunkGetClientPortalConfigurations = createAsyncThunk<
  IClientPortalConfiguration[],
  undefined,
  { rejectValue: Error }
>('clientPortalChats/getClientPortalConfigurations', async (_, { rejectWithValue }) => {
  try {
    const response = await getClientPortalConfigurations();
    return response.data;
  } catch (error) {
    const { data } = error as {
      data: Error;
    };
    return rejectWithValue(data);
  }
});
